<template>
<div>
     <navbar/>
    <!-- <div class="container">
			<h3 class="gixcore">Thank<h3 class="gixcore" style="color: #1997c6 !important"> You! </h3></h3>
        <h4 class="p">The confirmation link was sent to [email]</h4>
    </div> -->
    <div class="container">
			<h3 class="gixcore">Thank<h3 class="gixcore" style="color: #1997c6 !important"> You! </h3></h3>
        <h4 class="p">Your account was created. You may now <router-link to="/users/login">sign in</router-link></h4>
    </div>
</div>
</template>

<script>
import navbar from '../navbar.vue'
export default {
    name: 'RegisterSuccess',
    components: {
        navbar
    }
}
</script>

<style scoped>
h4 {
    color: #B2B3B4 !important
}
nav {
    position: relative;
}
.p {
    margin-top: 3%;
}
.blue {
    color: #1997c6
}
.container {
    text-align: center;
    margin-top: 10%;
}
.gixcore {
    margin-bottom: 5% !important;
    font-size: 28pt
}
</style>